import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  justify-content: center;
`
export const SearchingArea = styled.div`
  margin-top: 0.5rem;
  display: flex;
  justify-content: center;
`;
